<template>
  <nav class="controlpanel__nav">
    <v-list>
      <v-list-item
        v-for="item in items"
        :key="item.title"
        :to="{ name: item.href }"
        active-class="primary--text"
      >
        <v-list-item-action>
          <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </nav>
</template>

<script>
export default {
  name: 'EmployeeControlpanelMenu',
  computed: {
    items() {
      const items = [
        {
          icon: 'person',
          title: this.$i18n.t('texts.profile'),
          href: 'employee.profile',
        },
        {
          icon: 'assignment',
          title: this.$i18n.t('texts.resume'),
          href: 'employee.resume',
        },
        {
          icon: 'favorite',
          title: this.$i18n.t('texts.favorites'),
          href: 'employee.favorite',
        },
        {
          icon: 'insert_drive_file',
          title: this.$i18n.t('texts.applications'),
          href: 'employee.application',
        },
        {
          icon: 'file_copy',
          title: this.$i18n.tc('texts.cooperationAgreement', 2),
          href: 'employee.cooperation-agreements',
        },
      ];
      return items;
    },
  },
};
</script>
